import { api } from '@config/api';
import type { FiltrosUsuarios, Usuario } from '../types/Usuario';

export const POR_PAGINA_OPCOES = [20, 50, 100] as const;
export const POR_PAGINA_PADRAO = 20;

export const usuariosService = {
  /** `''` e `[]` não vão; listas vão repetidas (`perfil=a&perfil=b`), como no painel. */
  listar: ({ ordenar, ...f }: FiltrosUsuarios) =>
    api
      .get<{ itens: Usuario[]; total: number }>('/perfis/usuarios', {
        params: Object.fromEntries(
          Object.entries({ ...f, ordenar }).filter(
            ([, v]) => v !== '' && !(Array.isArray(v) && v.length === 0),
          ),
        ),
        paramsSerializer: { indexes: null },
      })
      .then((r) => r.data),
  promover: (id: string) =>
    api.post<Usuario>(`/perfis/usuarios/${id}/administrador`).then((r) => r.data),
  rebaixar: (id: string) =>
    api.delete<Usuario>(`/perfis/usuarios/${id}/administrador`).then((r) => r.data),
};
